<template>
  <div class="container my-1" id="telaPrincipal" v-if="origemAcesso === 'AD'">
    <div>
      <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
        <p>
          <b-alert show variant="success" dismissible>{{ i }}</b-alert>
        </p>
      </div>
      <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
        <p>
          <b-alert show variant="danger" dismissible>
            <b-icon variant="danger" icon="x-circle-fill" />
            {{ i }}
          </b-alert>
        </p>
      </div>
      <div class="mt-0">
        <!-- ABA DADOS GERAIS -->
        <b-button variant="primary" class="float-right" v-b-modal.modal-1 @click="buscarPerguntasRespostas">
          Nova Pergunta
        </b-button>
        <form @submit.prevent>
          <h2 class="title">Cadastro Perguntas</h2>
          <b-card>
            <div>
              <span class="title h5" v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Pesquisar as perguntas.">
                Pesquisar Perguntas
                <b-icon variant="primary" icon="info-circle-fill" class="ml-2" />
              </span>
              <p></p>
              <b-row class="mb-2 mt-0">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="dscTitulo" class="pb-3">Título</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="dscTitulo" type="search" class="ml-3" v-model="filtroPerguntas.dscTitulo">
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-0">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="dscPergunta" class="pb-3">Pergunta</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="dscPergunta" type="search" class="ml-3" v-model="filtroPerguntas.dscPergunta">
                  </b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-0">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="dscResposta" class="pb-3">Resposta</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input id="dscResposta" type="search" class="ml-3" v-model="filtroPerguntas.dscResposta">
                  </b-form-input>
                </b-col>
              </b-row>
            </div>

            <b-button variant="primary" class="ml-3 mr-3 float-right" @click.prevent="pesquisar">
              Pesquisar
            </b-button>
            <b-button variant="secondary" class="float-right" @click.prevent="limpar">
              Limpar Filtro
            </b-button>
          </b-card>
          <h2 class="title">Seleção de Perguntas</h2>
          <b-card>
            <tabelaPerguntas :dadosPerguntas="lista" :agrupaPerguntas="agrupaPerguntas" :mensagemSucesso="mensagemSucesso"  v-on:mostrarMensagemOK="getmensOK($event)"/>
            <div v-if="lista.length === 0">
              Nenhum Resultado Encontrado
            </div>
          </b-card>
        </form>
      </div>
    </div>
    <div id="fimPagina"></div>

    <!-- Modal Nova Pergunta -->
    <b-modal id="modal-1" title="Cadastrar Nova Pergunta" ref="dialog-confirmar-selecao" hide-footer size="sm"
      modal-class="-modal" centered @hidden="resetModal">
      <form ref="form" @submit.prevent="cadastrarPergunta">
        <b-form-group>
          <b-form-checkbox v-model="values.novoAgrupamento">Marcar para inserir novo
            título</b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="!values.novoAgrupamento" label="Título">
          <b-form-select v-model="values.codAgrupamento" :options="opcoesStatus"></b-form-select>
        </b-form-group>
        <b-form-group v-if="values.novoAgrupamento" label="Nome do Título" label-for="nome-agrupamento-input"
          invalid-feedback="Agrupamento is required">
          <b-form-input id="nome-agrupamento-input" v-model="values.nomeAgrupamento" required></b-form-input>
        </b-form-group>
        <b-form-group label="Pergunta" label-for="pergunta-input" invalid-feedback="Pergunta is required"
          :state="values.perguntaState">
          <b-form-textarea id="pergunta-input" v-model="values.pergunta" :state="values.perguntaState" required
            rows="4"></b-form-textarea>
        </b-form-group>
        <b-form-group label="Resposta" label-for="resposta-input" invalid-feedback="Resposta is required"
          :state="values.respostaState">
          <b-form-textarea id="resposta-input" v-model="values.resposta" :state="values.respostaState" required
            rows="4"></b-form-textarea>
        </b-form-group>
        <b-button type="submit" variant="primary" class="ml-3 mr-3 float-right">
          Cadastrar
        </b-button>
        <b-button variant="secondary" class="float-right" @click="resetModal">
          Limpar
        </b-button>
      </form>
    </b-modal>
  </div>
</template>
  
<script>
import tabelaPerguntas from "../components/tabelaPerguntas.vue";
import constantes from "../constants/index";
import normalizaMensagemApi from '../helpers/normalizaMensagemApi';

export default {
  components: {
    tabelaPerguntas,
  },
  data() {
    return {
      userName: '',
      origemAcesso: '',
      origemNome: '',
      carregando: false,
      mensagemSucesso: [],
      mensagemErro: [],
      lista: [],
      listaOriginal: [],
      agrupamento: [],
      filtroPerguntas: {
        dscPergunta: '',
        dscResposta: '',
        dscTitulo: ''
      },
      opcoesStatus: [],
      lancamentos: [],
      lancamentosSelecionados: [],
      refazerAgrupamento: [],
      values: {
        pergunta: '',
        resposta: '',
        codAgrupamento: '',
        nomeAgrupamento: '',
        perguntaState: null,
        respostaState: null,
        novoAgrupamento: false
      },
    }
  },
  methods: {
    carregarAgrupaPerguntas: async function () {
      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaPerguntas)
        .then((response) => {
          const retorno = response.data;
          const listaPerguntas = retorno[0];        
          this.opcoesStatus = listaPerguntas.map(pergunta => ({
            value: pergunta.ID_DRAM_AGRUPA_PERGUNTAS,
            text: pergunta.DESCRICAO
          }));
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          this.carregando = false;
          window.scrollTo(0, 0);
        });
    },
    getmensOK(data) {                          
        this.mensagemSucesso = data.mensOK;
     },
    agrupaPerguntas: async function () {
      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaPerguntas)
        .then((response) => {
          const retorno = response.data;
          const listaPerguntas = retorno[0];           
          this.listaOriginal = listaPerguntas;
          this.lista = listaPerguntas.slice();  
          window.scrollTo(0, 0);       
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          this.carregando = false;
          window.scrollTo(0, 0);
        });
    },
    buscarPerguntasRespostas: async function () {
      await this.$axios
        .get(this.$env.url_backend + constantes.buscarPerguntasRespostas, {})
        .then((response) => {
          const retorno = response.data;
          const listaPerguntas = retorno;       
          this.opcoesStatus = listaPerguntas.map(vl => ({
            value: vl.ID_DRAM_AGRUPA_PERGUNTAS,
            text: vl.DESCRICAO
          }));
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          this.carregando = false;
          window.scrollTo(0, 0);
        });
    },
    cadastrarPergunta: async function () {
      if (!this.checkFormValidity()) {
        return;
      }
      let codAgrupamento = this.values.novoAgrupamento ? 0 : this.values.codAgrupamento;
      try {
        this.mensagemErro = [];
        this.mensagemSucesso = [];
        await this.$axios
          .post(this.$env.url_backend + constantes.cadastrarPerguntaResposta, {
            pergunta: this.values.pergunta,
            resposta: this.values.resposta,
            codAgrupamento: codAgrupamento,
            novoAgrupamento: this.values.novoAgrupamento,
            nomeAgrupamento: this.values.nomeAgrupamento,
            userName: this.userName
          })
          .then((response) => {
            if (response.status === 201) {
              this.mensagemSucesso.push(
                response.data.message
              );
              this.agrupaPerguntas();
            }
          });
      } catch (error) {
        const mensagem = normalizaMensagemApi(error);
        this.mensagemErro.push(mensagem);
        this.carregando = false;
        this.mensagemErro.push(
          error.message
        );
        window.scrollTo(0, 0);
      }

      // Hide the modal manually
      this.$bvModal.hide("modal-1");
    },
    limpar() {
      this.filtroPerguntas = {
        dscTitulo: '',
        dscPergunta: '',
        dscResposta: '',
      };
      this.agrupaPerguntas();
    },
    pesquisar() {
      const filtro = this.filtroPerguntas;
      const listaOriginalFiltrada = this.listaOriginal.map(item => ({ ...item }));

      this.lista = listaOriginalFiltrada.filter(item => {
        const dscTitulo = filtro.dscTitulo ? item.DESCRICAO.toLowerCase().includes(filtro.dscTitulo.toLowerCase()) : true;
        const perguntasFiltradas = item.PERGUNTAS_RESPOSTAS.filter(pergunta => {
          const dscPergunta = filtro.dscPergunta ? pergunta.PERGUNTA.toLowerCase().includes(filtro.dscPergunta.toLowerCase()) : true;
          const dscResposta = filtro.dscResposta ? pergunta.RESPOSTA.toLowerCase().includes(filtro.dscResposta.toLowerCase()) : true;
          return dscPergunta && dscResposta;
        });
        item.PERGUNTAS_RESPOSTAS = perguntasFiltradas;
        return dscTitulo && perguntasFiltradas.length > 0;
      });
    },
    resetModal() {
      this.values.pergunta = "";
      this.values.resposta = "";
      this.values.codAgrupamento = '';
      this.values.novoAgrupamento = false;
      this.values.nomeAgrupamento = "";
      this.values.perguntaState = null;
      this.values.respostaState = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.values.perguntaState = valid;
      this.values.respostaState = valid;
      return valid;
    },
  },

  watch: {
    'values.novoAgrupamento': function (novoAgrupamento) {
      if (novoAgrupamento) {
        this.values.codAgrupamento = '';
      }
      if (!novoAgrupamento) {
        this.values.nomeAgrupamento = '';
      }
    }
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
  },
  async mounted() {
    this.agrupaPerguntas();
  },
  created() {
    this.carregando = true;
  },

};
</script>
  
<style lang="css" scoped>
.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

hr {
  border-color: #aaa;
  box-sizing: border-box;
  width: 100%;
}

.tooltip .tooltiptext {
  width: 20px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.inner-btn.btn_tam {
  width: 10px;
  height: 20px;
}

.botao {
  width: 150px;
  height: 80px;
}

.inner-btn {
  position: absolute;
  width: 10px;
  font-weight: 550;
  border: none;
  background-color: transparent;
  line-height: 35px;
  left: calc(100% - 30px);
  z-index: 99999;
}

.inner-btn:hover {
  color: blue;
}
</style>